import { render, staticRenderFns } from "./plattaskprocess.vue?vue&type=template&id=156d2584&"
import script from "./plattaskprocess.vue?vue&type=script&lang=js&"
export * from "./plattaskprocess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports